module.exports = __webpack_public_path__ + "static/img/manual_zh_24.b462cea.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zh/manual_zh_24.png
// module id = w6rm
// module chunks = 4